export const featured = [
  {
    id: 1,
    title: "Face Recognition Using MTCNN & Inception ResNet V1",
    description: "Real-time face recognition & detection system leveraging MTCNN for face alignment and InceptionResNetV1 for deep face embeddings from live camera feeds.",
    imageUrl: "/images/facenet2.png",
    githubUrl: "https://github.com/jerwingubat/FaceNet-FaceRecognition",
    tags: ["Python", "PyTorch", "MTCNN", "ResNet", "OpenCV"],
    category: "Machine Learning"
  },
  {
    id: 2,
    title: "SweeTrack Food & Calorie Tracker App",
    description: "Food recognition Android app that identifies food items, estimates caloric & sugar intake, and guides dietary choices based on health conditions.",
    imageUrl: "/images/sweetrack.jpg",
    githubUrl: "https://github.com/jerwingubat/SweeTrack-App",
    tags: ["Android", "Kotlin", "TensorFlow Lite", "Firebase"],
    category: "Mobile & AI"
  },
  {
    id: 5,
    title: "NutriScan",
    description: "NutriScan is a web app that lets users scan food barcodes and quickly view nutritional information, making it easier to understand products and make healthier choices.",
    imageUrl: "/images/expense-tracker.png",
    liveUrl: "https://expensescanner.vercel.app/",
    tags: ["React", "JavaScript", "Express"],
    category: "Web Development"
  },
  {
    id: 5,
    title: "BudgetFlow",
    description: "BudgetFlow is a web app that helps users manage their finances by tracking expenses, setting budgets, and providing insights into spending habits.",
    imageUrl: "/images/budget-tracker.png",
    liveUrl: "https://budget-tracker-ten-beryl.vercel.app/",
    tags: ["React", "JavaScript", "Express"],
    category: "Web Development, Web App"
  },
  {
    id: 3,
    title: "CVSU Syllabus Draft Generator",
    description: "AI-assisted web application for educators to quickly craft structured course syllabi and detailed learning roadmaps based on topic parameters.",
    imageUrl: "/images/roadmap-studio.png",
    liveUrl: "https://road-map-generator.vercel.app/",
    githubUrl: "https://github.com/jerwingubat",
    tags: ["React", "Tailwind CSS", "Vercel", "Node.js"],
    category: "Web Development"
  },
  {
    id: 4,
    title: "Research Title Generator",
    description: "AI-driven utility assisting CS & IT students in generating creative, domain-specific project titles tailored to AI, Mobile, and Web stacks.",
    imageUrl: "/images/titleGenerator.jpg",
    liveUrl: "https://titlegenerator.vercel.app/",
    githubUrl: "https://github.com/jerwingubat",
    tags: ["React", "Next.js", "OpenAI API", "Tailwind"],
    category: "Web & AI"
  },
  {
    id: 5,
    title: "JARVIS Clone",
    description: "A voice-controlled AI assistant inspired by Tony Stark's JARVIS, built with Python. Features a sleek Iron Man-style UI with an arc reactor animation, continuous voice recognition, and AI-powered responses.",
    imageUrl: "/images/JARVIS.png",
    githubUrl: "https://github.com/jerwingubat/J.A.R.V.I.S-CLONE",
    tags: ["Python", "NumPy", "PyQt6", "SpeechRecognition"],
    category: "Personal AI Assistant"
  }
];

export const projects = [
  {
    id: 1,
    title: "Face Recognition MTCNN",
    description: "Real-time face detection and embedding comparison using PyTorch and OpenCV.",
    imageUrl: "/images/facenet2.png",
    githubUrl: "https://github.com/jerwingubat/FaceNet-FaceRecognition",
    tags: ["Python", "PyTorch", "OpenCV"],
    category: "Machine Learning"
  },
  {
    id: 2,
    title: "CVSU Syllabus Generator",
    description: "Automated curriculum and roadmap generator for university instructors.",
    imageUrl: "/images/roadmap-studio.png",
    liveUrl: "https://road-map-generator.vercel.app/",
    tags: ["React", "Node.js", "Tailwind"],
    category: "Web Development"
  },
  {
    id: 5,
    title: "BudgetFlow",
    description: "BudgetFlow is a web app that helps users manage their finances by tracking expenses, setting budgets, and providing insights into spending habits.",
    imageUrl: "/images/budget-tracker.png",
    liveUrl: "https://budget-tracker-ten-beryl.vercel.app/",
    tags: ["React", "JavaScript", "Express"],
    category: "Web Development, Web App"
  },
  {
    id: 3,
    title: "Research Title Generator",
    description: "AI tool for CS/IT students to generate capstone and thesis project ideas.",
    imageUrl: "/images/titleGenerator.jpg",
    liveUrl: "https://titlegenerator.vercel.app/",
    tags: ["React", "AI", "Tailwind"],
    category: "Web & AI"
  },
  {
    id: 4,
    title: "SweeTrack App",
    description: "Mobile app estimating calorie and sugar content from food photos.",
    imageUrl: "/images/sweetrack.jpg",
    githubUrl: "https://github.com/jerwingubat/SweeTrack-App",
    tags: ["Kotlin", "Android", "TFLite"],
    category: "Mobile App"
  },
  {
    id: 5,
    title: "FoodBud",
    description: "Health-focused food prohibition detector based on medical profiles.",
    imageUrl: "/images/foodbudlogo.png",
    githubUrl: "https://github.com/jerwingubat/FoodBud",
    tags: ["React", "JavaScript", "Express"],
    category: "Web Development"
  },
  {
    id: 5,
    title: "NutriScan",
    description: "NutriScan is a web app that lets users scan food barcodes and quickly view nutritional information, making it easier to understand products and make healthier choices.",
    imageUrl: "/images/expense-tracker.png",
    liveUrl: "https://expensescanner.vercel.app/",
    tags: ["React", "JavaScript", "Express"],
    category: "Web Development"
  },
  {
    id: 6,
    title: "AngelCare Website",
    description: "Modern website for senior assisted living featuring service details & contact flows.",
    imageUrl: "/images/angelCare.png",
    liveUrl: "https://angelcareassistedliving.vercel.app/",
    tags: ["React", "Tailwind", "Responsive"],
    category: "Web Design"
  },
  {
    id: 7,
    title: "Modular ML Algorithms",
    description: "Clean Python implementations of core machine learning algorithms from scratch.",
    imageUrl: "/images/machineLearning.PNG",
    githubUrl: "https://github.com/jerwingubat/Machine-Learning-Algorithms",
    tags: ["Python", "NumPy", "Scikit-Learn"],
    category: "Machine Learning"
  },
  {
    id: 8,
    title: "JARVIS Clone",
    description: "A voice-controlled AI assistant inspired by Tony Stark's JARVIS, built with Python. Features a sleek Iron Man-style UI with an arc reactor animation, continuous voice recognition, and AI-powered responses.",
    imageUrl: "/images/JARVIS.png",
    githubUrl: "https://github.com/jerwingubat/J.A.R.V.I.S-CLONE",
    tags: ["Python", "NumPy", "PyQt6", "SpeechRecognition"],
    category: "Personal AI Assistant"
  },
  {
    id: 9,
    title: "Online Exam Proctor",
    description: "Real-time database test environment with active tab monitoring for integrity.",
    imageUrl: "/images/examMonitoring.PNG",
    githubUrl: "https://github.com/jerwingubat/OnlineExamMonitoring",
    tags: ["Firebase", "JavaScript", "HTML5"],
    category: "Web Application"
  }
];

export const skillCategories = [
  {
    title: "Machine Learning & AI",
    description: "Computer vision, neural networks, and model deployment.",
    skills: [
      { name: "Python", icon: "devicon-python-plain", color: "#3776AB" },
      { name: "PyTorch / TensorFlow", icon: "devicon-tensorflow-original", color: "#FF6F00" },
      { name: "OpenCV & MTCNN", icon: "devicon-opencv-plain", color: "#5C3EE8" }
    ]
  },
  {
    title: "Web Development",
    description: "Frontend frameworks, modern styling, and responsive UIs.",
    skills: [
      { name: "React.js", icon: "devicon-react-original", color: "#61DAFB" },
      { name: "JavaScript / ES6+", icon: "devicon-javascript-plain", color: "#F7DF1E" },
      { name: "Tailwind CSS", icon: "devicon-tailwindcss-plain", color: "#38B2AC" },
      { name: "HTML5 / CSS3", icon: "devicon-css3-plain", color: "#1572B6" }
    ]
  },
  {
    title: "Backend & Databases",
    description: "Server runtimes, APIs, and data storage solutions.",
    skills: [
      { name: "Node.js & Express", icon: "devicon-nodejs-plain", color: "#339933" },
      { name: "Java & Kotlin", icon: "devicon-java-plain", color: "#007396" },
      { name: "MySQL & MongoDB", icon: "devicon-mysql-plain", color: "#4479A1" },
      { name: "Firebase Backend", icon: "devicon-firebase-plain", color: "#FFCA28" }
    ]
  },
  {
    title: "Mobile & Architecture",
    description: "Cross-platform mobile apps & software design.",
    skills: [
      { name: "Android Studio / Kotlin", icon: "devicon-kotlin-plain", color: "#7F52FF" },
      { name: "Flutter", icon: "devicon-flutter-plain", color: "#08589C" },
      { name: "Git & DevOps", icon: "devicon-git-plain", color: "#F05032" }
    ]
  }
];

export const skills = [
  { id: 1, title: "Java", description: "Object-oriented programming", icon: "devicon-java-plain", color: "#007396" },
  { id: 2, title: "Kotlin", description: "Modern Android development", icon: "devicon-kotlin-plain", color: "#7F52FF" },
  { id: 3, title: "Flutter", description: "Cross-platform mobile UI", icon: "devicon-flutter-plain", color: "#08589C" },
  { id: 4, title: "ExpressJS", description: "Node.js REST API framework", icon: "devicon-express-original", color: "#005288" },
  { id: 5, title: "NodeJS", description: "Event-driven runtime environment", icon: "devicon-nodejs-plain", color: "#339933" },
  { id: 6, title: "Tailwind CSS", description: "Utility-first design tokens", icon: "devicon-tailwindcss-plain", color: "#38B2AC" },
  { id: 7, title: "React", description: "Declarative component UIs", icon: "devicon-react-plain", color: "#61DAFB" },
  { id: 8, title: "JavaScript", description: "Fullstack web programming", icon: "devicon-javascript-plain", color: "#F7DF1E" },
  { id: 9, title: "PHP", description: "Backend web scripting", icon: "devicon-php-plain", color: "#777BB4" },
  { id: 10, title: "Python", description: "AI, ML & data scripting", icon: "devicon-python-plain", color: "#3776AB" },
  { id: 11, title: "Git", description: "Distributed version control", icon: "devicon-git-plain", color: "#F05032" },
  { id: 12, title: "MySQL", description: "Relational database engine", icon: "devicon-mysql-plain", color: "#4479A1" },
  { id: 13, title: "Firebase", description: "Realtime cloud & auth", icon: "devicon-firebase-plain", color: "#FFCA28" },
  { id: 14, title: "MongoDB", description: "Document-oriented NoSQL", icon: "devicon-mongodb-plain", color: "#47A248" }
];

export const services = [
  {
    id: 1,
    title: "Web Application Development",
    description: "Crafting modern, responsive web applications using React, Tailwind CSS, and Node.js with optimized performance and sleek glassmorphism UI/UX design.",
    icon: "code",
    color: "#6366F1"
  },
  {
    id: 2,
    title: "Machine Learning & AI Integration",
    description: "Developing and deploying custom ML models, computer vision systems (MTCNN / FaceNet), and AI-assisted automation tools.",
    icon: "cpu",
    color: "#06B6D4"
  },
  {
    id: 3,
    title: "Mobile App Development",
    description: "Building native Android apps with Kotlin and cross-platform mobile solutions using Flutter integrated with Firebase backends.",
    icon: "smartphone",
    color: "#10B981"
  },
  {
    id: 4,
    title: "CS Instruction & Technical Mentorship",
    description: "Delivering high-quality undergraduate computer science education, curriculum design, research guidance, and technical workshops.",
    icon: "graduation-cap",
    color: "#F59E0B"
  }
];

export const articles = [
  {
    id: 1,
    title: "The Hidden Language: Why Mathematics is the Backbone of Computer Science",
    description: "An exploration of how mathematical principles underpin algorithm design, cryptography, and artificial intelligence innovation.",
    imageUrl: "/images/article1.png",
    categories: ["Mathematics", "Computer Science"],
    readTime: "3 min read",
    link: "https://medium.com/@jerwinfaderanga/the-hidden-language-why-mathematics-is-the-backbone-of-computer-science-9ae855ed1445",
    date: "May 2023"
  },
  {
    id: 2,
    title: "Programming in the Age of AI: Reshaping the Coding Landscape",
    description: "How intelligent developer tools and generative AI models amplify developer productivity while creating new paradigms.",
    imageUrl: "/images/article2.png",
    categories: ["DevOps", "AI Tools"],
    readTime: "3 min read",
    link: "https://medium.com/@jerwinfaderanga/programming-in-the-age-of-ai-51de2bafeabb",
    date: "April 2023"
  },
  {
    id: 3,
    title: "Machine Learning and AI in the 21st Century: Innovation vs Inequality",
    description: "Analyzing the societal, ethical, and economic implications of widespread artificial intelligence adoption.",
    imageUrl: "/images/article3.png",
    categories: ["Artificial Intelligence", "Ethics"],
    readTime: "5 min read",
    link: "https://medium.com/@jerwinfaderanga/machine-learning-and-ai-in-the-21st-century-towards-a-new-age-of-innovation-or-inequality-119fb7edd3ea",
    date: "March 2023"
  }
];

export const experiences = [
  /*{
    id: 1,
    title: "Owner & Lead Developer",
    company: "OptiByte Software Solutions",
    period: "2025 - 2026",
    description: "Directing custom software development projects, leading a team of developers building web applications, mobile platforms, and AI integrations for clients.",
    type: "Leadership"
  },*/
  {
    id: 1,
    title: "Senior Executive - CWFM",
    company: "EXL Service Philippines",
    period: "2026 - Present",
    description: "Designing, developing, and maintaining websites and web-based applications to support business operations, improve user experience, and streamline internal workflows. Responsible for front-end development, functionality implementation, troubleshooting, and website optimization.",
    type: "Corporate"
  },
  {
    id: 2,
    title: "Computer Science Instructor",
    company: "Cavite State University - CCAT Campus",
    period: "2023 - 2026",
    description: "Instructing undergraduate CS courses, curriculum development, research advising, and guiding capstone software projects.",
    type: "Academia"
  },
  {
    id: 3,
    title: "Architectural Engineering / AutoCAD Specialist",
    company: "HRD Singapore Pte. Ltd.",
    period: "2023 - 2023",
    description: "Prepared technical layouts, project documentation, and coordinated team deliverables for precision engineering projects.",
    type: "Engineering"
  },
  {
    id: 4,
    title: "Freelance Fullstack Developer",
    company: "Global Clients (Upwork / Fiverr)",
    period: "2021 - 2025",
    description: "Delivered custom web and mobile applications, API integrations, database optimization, and client solutions.",
    type: "Freelance"
  }
];